import { JuloUpdateEntry } from "./types"

export const filerPaJobbEntry: JuloUpdateEntry = {
  slug: "2026-05-13-filer-pa-jobb",
  date: "2026-05-13",
  title: "Ladda upp filer och bilder på ett jobb",
  description:
    'Nu kan ni bifoga filer på ett jobb — direkt i mottagningen under "Övrigt", och från jobbets detaljsida via menyn med tre prickar. Klick på en fil öppnar den i en ny flik. Bilder komprimeras automatiskt till under 1 MB, PDF får vara max 20 MB, och ni kan ha upp till 10 filer per jobb. Filerna visas i kortet "Filer" så fort en eller fler är uppladdade.',
}
